module.exports = __webpack_public_path__ + "img/top-location.f10a25eb.svg";